// extracted by mini-css-extract-plugin
module.exports = {"shareBtns":"ShareBtns_shareBtns__2JqMm","shareBtnsTitle":"ShareBtns_shareBtnsTitle__axMxe","shareBtn":"ShareBtns_shareBtn__LEkDL","inline":"ShareBtns_inline__12gid"};